export default {
    prequal: {
        schema: {
            errorMessages: {
                loanAmount: 'Loan amount must be between $2,000 and $35,000',
                loanPurpose: 'Loan purpose is required',
                loanPurposeOther: 'Other purpose is required',
                province: 'Province is required',
                unsupportedProvince: 'Fig currently does not operate in Northwest Territories, Yukon and Nunavut. We apologize for the inconvenience.',
                firstName: 'Legal first name is required',
                lastName: 'Legal last name is required',
                email: 'Invalid email address',
                emailTaken: 'Please enter a different email address',
                dateOfBirth: 'Date of birth is required',
                dateOfBirthOutOfRange: 'Please enter a valid date of birth',
                dateOfBirthUnderAge: 'Fig cannot offer a loan to minors',
                fullAddress: 'Please enter a valid address',
                poBoxNotAllowed: 'We do not allow PO boxes',
                city: 'City is required',
                postalCode: 'Postal code is required',
                postalCodeInvalid: 'Please enter a valid Canadian postal code (e.g., K1A 0A6)',
                phoneNumber: 'Please enter a valid Canadian phone number',
                phoneNumberTaken: 'Please enter a different phone number',
                employmentStatus: 'Employment status is required',
                occupationType: 'Occupation type is required',
                occupation: 'Occupation is required',
                jobTitle: 'Job title is required',
                employerName: 'Employer name is required',
                jobStartDate: 'Job start date is required',
                jobStartDateInvalid: 'Enter a valid start month and year (MM/YYYY)',
                annualIncome: 'Please enter a valid annual income amount',
                annualIncomeBelowMinimum: 'Annual income must be greater than $10,000',
                housingStatus: 'Housing status is required',
                monthlyHousingPayment: 'Monthly rent must be positive',
                livedAtAddressSince: 'Lived at address since is required',
                residencyStatus: 'Residency status is required',
                residencyStatusOther: 'Other residency status is required',
                levelOfEducation: 'Level of education is required',
                loanInLastThreeMonths: 'Please select an option',
                savingsAmount: 'Enter a valid amount',
                vehicleOwnership: 'Please select an option'
            }
        },
        loanamount: {
            title: 'Check your rate in 1 minute!',
            subtitle: 'How much would you like to borrow?',
            keyPointsSection: {
                title: 'Personal loan with {{partner}}:',
                point1: 'Fully digital application process',
                point2: 'Funds deposited in as little as 1 business day',
                point3: 'No early repayment fees'
            }
        },
        loanPurpose: {
            label: 'Loan Purpose',
            loanPurpose: 'Loan Purpose',
            DEBT_CONSOLIDATION: 'Debt Consolidation',
            EXPENSES: 'Expenses',
            HOME_IMPROVEMENT: 'Home Improvement',
            EMERGENCY: 'Emergency',
            AUTOMOBILE_FINANCING_OR_REPAIR: 'Automobile Financing / Repair',
            EDUCATION: 'Education',
            PERSONAL_INVESTMENT: 'Personal Investment',
            OTHER: 'Other'
        },
        loanPurposeOther: {
            label: 'Other Purpose'
        },
        aboutYourselfStep: {
            title: 'Tell us about yourself',
            subtitle: 'This helps us confirm your identity',
            firstName: {
                label: 'Legal first name',
                placeholder: 'Legal first name'
            },
            lastName: {
                label: 'Legal last name',
                placeholder: 'Legal last name'
            },
            legalNameHint: 'Use the name exactly as it appears on your government-issued ID. Example: Jonathan (not Jon)',
            email: {
                label: 'Email address',
                placeholder: 'Email address'
            },
            disclaimer: {
                text: "By continuing, you agree to Fig Financial Inc's <0>Terms and Conditions</0> and <1>Privacy Statement</1>.",
                title: 'Privacy Notice'
            },
            disclaimerQC:
                'By continuing, you agree to our <0>Terms and Conditions</0>.<br/> By continuing, you consent to the collection, use and sharing of the information that you provide (or authorize to be provided) to process your application and service your loan in accordance with our <1>Privacy Statement</1>. For questions regarding your rights, how your information is processed (including processing outside of your province or Canada) or to withdraw consent, visit our Privacy Statement or contact our Privacy Officer.',
            disclaimerQCContent: {
                content: `{{partner}} collects, uses, and shares your personal information in order to:
-- start bullet points --
evaluate your application, including determine your eligibility for a loan by obtaining a credit check from a consumer reporting agency (with your consent);
periodically assessing your eligibility and ongoing creditworthiness and determining your suitability for products or services offered by us, our affiliates, our partners or other selected third parties;

share Information with third parties (who may be located outside of the jurisdiction in which you are located), including our affiliates, service providers, credit bureaus, reporting agencies, and references you provide in this application;

unless you opt out, share information with our affiliates so that they may contact you directly about their own products and services;

detect and prevent fraud and unauthorized activities, including the use, by {{partner}}, of a third-party fraud prevention partner;

collect outstanding debts in connection with your loan;

communicate with you about your loan; and

meet legal and regulatory requirements.
-- end bullet points --
Visit our <0>Privacy Statement</0> or contact us if you have questions about your rights to access, rectify, or withdraw your consent to process your personal information; or how we or our service providers (including those outside your province or Canada) treat your personal information.

Privacy Officer
Fig Financial Inc.
630 Rene Levesque Blvd West, Suite 1400
Montréal QC H3B 1S6
1-844-431-3444
privacy@fig.ca
`,
                closingParagraph:
                    'Visit our <0>Privacy Statement</0> or contact us if you have questions about your rights to access, rectify, or withdraw your consent to process your personal information; or how we or our service providers (including those outside your province or Canada) treat your personal information.'
            },
            termsText: 'Terms and Conditions',
            privacyText: 'Privacy Statement',
            termsLink: {
                fig: 'https://fig.ca/en/legal/terms-and-conditions/',
                kizzo: 'https://kizzo.ca/en/terms-and-conditions'
            },
            privacyLink: {
                fig: 'https://fig.ca/en/legal/privacy-policy/',
                kizzo: 'https://kizzo.ca/en/privacy-statement'
            }
        },
        personalInfoStep: {
            title: 'Just a few more details',
            subtitle: 'This helps us confirm your identity',
            dateOfBirth: {
                label: 'Date of Birth'
            },
            phoneNumber: {
                label: 'Phone Number',
                placeholder: 'Phone Number'
            },
            address: {
                label: 'Address',
                placeholder: 'Address',
                autocompleteRequired:
                    "Please select an address from the list. Can't find it? Add your city (e.g. 31 King St W Toronto), then choose a suggestion.",
                incompleteSuggestion: 'That suggestion is missing a valid province. Please pick a different address from the list.',
                lockedFieldsHint: 'To change city, province, or postal code, select a different address above.'
            },
            address2: {
                label: 'Unit number (if applicable)',
                placeholder: 'Unit number (if applicable)'
            },
            city: {
                label: 'City',
                placeholder: 'City'
            },
            province: {
                label: 'Province',
                placeholder: 'Province'
            },
            postalCode: {
                label: 'Postal Code',
                placeholder: 'Postal Code'
            },
            residencyStatus: {
                label: 'Residency Status in Canada',
                placeholder: 'Residency Status in Canada',
                CITIZEN: 'Canadian citizen',
                PERMANENT_RESIDENT: 'Permanent resident',
                WORK_PERMIT: 'Work permit',
                INTERNATIONAL_STUDENT: 'International student',
                OTHER: 'Other',
                otherResidencyStatus: 'Other Status'
            }
        },
        provinces: {
            AB: 'Alberta',
            BC: 'British Columbia',
            MB: 'Manitoba',
            NB: 'New Brunswick',
            NL: 'Newfoundland and Labrador',
            NS: 'Nova Scotia',
            NT: 'Northwest Territories',
            NU: 'Nunavut',
            ON: 'Ontario',
            PE: 'Prince Edward Island',
            QC: 'Quebec',
            SK: 'Saskatchewan',
            YT: 'Yukon'
        },
        employmentInfoStep: {
            title: "What's your employment status?",
            subtitle: 'This helps us determine your eligibility. We may verify this information later so try to be exact as possible.',
            employmentStatus: {
                label: 'Employment Status',
                employmentStatus: 'Employment Status',
                FULL_TIME_EMPLOYED: 'Full-time employed',
                PART_TIME_EMPLOYED: 'Part-time employed',
                SEASONAL_EMPLOYED: 'Seasonal employed',
                SELF_EMPLOYED: 'Self-employed',
                UNEMPLOYED: 'Unemployed',
                RETIRED: 'Retired',
                STUDENT: 'Student',
                DISABILITY_OR_LONG_TERM_LEAVE: 'Disability or long-term leave'
            },
            occupationType: {
                label: 'Occupation Type',
                occupationType: 'Occupation Type',
                informationTechnology: 'Information Technology and communications',
                healthcare: 'Healthcare and medicine',
                finance: 'Finance and banking',
                education: 'Education',
                retail: 'Retail',
                manufacturing: 'Manufacturing',
                hospitality: 'Hospitality and tourism',
                construction: 'Construction',
                transportation: 'Transportation',
                other: 'Other'
            },
            jobTitle: {
                label: 'Job Title',
                jobTitle: 'Job Title',
                softwareEngineer: 'Software Engineer',
                doctor: 'Doctor',
                lawyer: 'Lawyer',
                teacher: 'Teacher',
                retailManager: 'Retail Manager',
                manufacturingManager: 'Manufacturing Manager',
                hospitalityManager: 'Hospitality Manager',
                constructionManager: 'Construction Manager',
                transportationManager: 'Transportation Manager',
                other: 'Other'
            },
            employerName: {
                label: 'Employer Name'
            },
            jobStartDate: {
                label: 'Start Date (MM/YYYY)'
            },
            annualIncome: {
                label: 'Annual Income',
                title: 'Tell us how much you make in a year, before taxes and deductions.',
                keyPointsSection: {
                    title: 'Include your:',
                    point1: 'Individual annual base salary and/or wages',
                    point2: 'Earnings to date from bonus, commissions, and variable pay',
                    point3: 'Retirement, disability, pension, or public assistance income',
                    title2: 'Don’t include:',
                    point4: 'Household income'
                },
                highIncome: {
                    warning: 'This is unusually high — please confirm below.',
                    confirmPrompt: "That's <0>{{amount}}</0> a year — does that look right?",
                    editAmount: 'Edit amount',
                    confirmButton: "Yes, that's correct"
                }
            },
            levelOfEducation: {
                label: 'Level of Education',
                HIGH_SCHOOL_OR_LESS: 'High School or Less',
                SOME_COLLEGE: 'College / Associate Degree',
                BACHELORS: 'Bachelors Degree (e.g. BA, BS)',
                GRADUATE: 'Graduate or Professional Degree (e.g. MBA, PhD, MD,JD)',
                OTHER: 'Other'
            }
        },
        financialInfoStep: {
            title: 'A few quick financial questions',
            subtitle: 'This helps us determine your eligibility. We may verify this information later so try to be as exact as possible.',
            loanRecent: {
                label: 'Have you taken a loan in the last 3 months?',
                yes: 'Yes',
                no: 'No'
            },
            savings: {
                label: 'How much do you have in savings?',
                checkingPlaceholder: 'Checking & savings accounts',
                investmentPlaceholder: 'Investment accounts'
            },
            vehicle: {
                label: 'Do you currently own a vehicle?',
                options: {
                    FULLY_PAID: 'Yes, and it’s fully paid off',
                    LEASING: 'Yes, and I’m currently leasing it',
                    ACTIVE_AUTO_LOAN: 'Yes, and I have an active auto loan',
                    NONE: 'No, I don’t own a vehicle'
                }
            }
        },
        housingStatusStep: {
            title: "What's your housing status?",
            subtitle: 'This helps us determine your eligibility. We may verify this information later so try to be as exact as possible.',
            housingStatus: {
                label: 'Housing Status',
                OWNED: 'I own my home',
                RENTED: "I'm renting",
                LIVING_WITH_FAMILY_OR_FRIENDS: 'I’m living with families or friends'
            },
            helpText: 'If you share your monthly payment with someone, only include your share.',
            rentAmount: {
                label: 'Monthly Rent Amount',
                placeholder: 'Monthly Rent Amount'
            },
            mortgageAmount: {
                label: 'Monthly Mortgage Amount',
                placeholder: 'Monthly Mortgage Amount'
            },
            contributionAmount: {
                label: 'Monthly Housing Expense',
                placeholder: 'Monthly Housing Expense'
            },
            livingSince: {
                label: 'Lived here since (MM/YYYY)'
            },
            disclaimer:
                "By clicking 'Get my offer', you are proceeding with a {{partner}} loan application. This will result in a soft credit inquiry from TransUnion that will not affect your credit score.",
            cta: {
                buttonText: 'Get my offer'
            }
        },
        offerStep: {
            title: 'Congratulations, ',
            subtitle: "You're pre-qualified for up to",
            stillHaveQuestions: 'Still have questions?',
            contactUs: 'Contact us',
            offerExpiry: 'Offer expires {{date}}',

            monthlyPayment: {
                title: 'From',
                description: 'Monthly Payment',
                disclaimer: {
                    title: 'Monthly Payment',
                    content:
                        'Monthly payment shown is estimated and may slightly differ from actual amount owed. <br/> <br/> Fig doesn’t charge any fees on early repayment. If you make a lump-sum payment, your monthly payment will remain the same but you’ll be paying off your loan earlier than the selected term. '
                }
            },

            promo: {
                message: 'Special rate for you, plus a chance to win $12,000 in prize money!',
                alt: 'Promotional offer image'
            },
            quickFaq: {
                aprCalculated: {
                    title: 'How was your rate calculated?',
                    content:
                        "Your APR was automatically generated by our system based on your credit profile and other financial factors. It's determined through a standardized process and is not negotiable or influenced by customer service interactions."
                },
                fixedApr: {
                    title: 'What does guaranteed fixed APR mean?',
                    content:
                        'Fig does not believe in misleading `bait-and-switch` offers. That means that the fixed APR will remain unchanged as you complete your application and finalize the loan.\n\nThe Annual Percentage Rate (APR) represents the total cost of borrowing over a year, expressed as a percentage.'
                },
                nextSteps: {
                    title: 'Next steps',
                    content:
                        "Now that you've checked your offer, the next step is to complete your application—it only takes a few minutes! No calls, no paperwork, and no branch visits—everything is done online from the comfort of your home. Once your application is approved and your loan is booked, you'll receive your funds within 1–2 business days."
                }
            },
            reviews: {
                title: 'Trusted by thousands of happy Canadians',
                anna: {
                    title: 'Great new change to an always tedious process',
                    content: 'Great, simply and direct process. Amazing rate with no hidden fees. Everything done online seamlessly.',
                    customer: 'Anna'
                },
                chun: {
                    title: 'Best company to deal with for Personal Loan!',
                    content:
                        'One of the best financial companies to deal with. Was preapproved. Linked my bank account and then got instantly approved. Money came in 24 hrs after that. Extremely smooth and amazing service. Will be continuing to do business with this company for future financial needs!',
                    customer: 'Chun'
                },
                carrie: {
                    title: 'This Company have helped me so much…',
                    content:
                        'This Company have helped me so much without judgement more than I can express. The application process was straightforward and relatively easy to follow, with a quick response to my application. Thank you, thank you, thank you! The repayments are also set up automatically which helps a great deal. I would most certainly recommend this Company to others in need.',
                    customer: 'Carrie'
                },
                customer: {
                    title: 'Fig Financial made the entire process incredibly smooth and introvert-friendly — and I loved that…',
                    content:
                        "I was able to complete everything online without needing to speak to anyone directly, which was such a relief for me. The platform was clear, easy to navigate, and gave me exactly what I needed without any pressure or overwhelm. As someone who values privacy and simplicity, this experience was exceptional. I felt empowered and informed every step of the way. If you're like me and prefer to handle things quietly and efficiently, Fig Financial is a gem. Highly recommend.",
                    customer: 'Customer'
                },
                ramin: {
                    title: 'Caring',
                    content: 'Everything is accurate and clear according to the schedule and they do not surprise you at all.',
                    customer: 'Ramin'
                }
            },
            faq: {
                title: 'FAQ',
                lineOfCredit: {
                    title: 'Is this a line of credit?',
                    content:
                        "No, this is not a line of credit. Fig offers unsecured personal loans, which means you receive the full loan amount in one lump sum after approval. You then repay the loan through fixed payments on a set schedule. This differs from a line of credit, where you're approved for a borrowing limit and can draw funds as needed, paying interest only on the amount you use."
                },
                fullAmount: {
                    title: 'Do I need to take the full amount?',
                    content:
                        "Not at all! You're in control—on the next screen, you can choose the loan amount that works best for you, up to your pre-approved limit."
                },
                receiveFunds: {
                    title: 'When will I receive the funds?',
                    content:
                        "Once your loan is booked and confirmed, you'll receive a confirmation email with the exact date your funds will be deposited. Funds are typically sent to your connected bank account as soon as 1 business day, but the exact timing may vary depending on your bank. If you don't receive the confirmation email, please contact us at support@fig.ca."
                },
                payEarly: {
                    title: 'Can I pay off my loan early?',
                    content:
                        'Yes! You can manually submit additional payments, or pay your loan off in full outside of your regularly scheduled payments, at no additional cost right from your Fig account. As your balance decreases from additional payments, your regular payment amount will remain the same, though your loan term will be shortened and less interest will be paid overall.'
                },
                creditScore: {
                    title: 'Is there an impact on my credit score?',
                    content:
                        "Yes and no.\n\nChecking your offer was completely free and had no impact on your credit score.\n\nWhen you move forward with your loan application, we also used a soft credit check to help determine your eligibility—this doesn't affect your credit score either.\n\nOn the last step of the application process, we'll ask for your consent to run a hard credit check. That's the only point where your credit score could be affected—and only if you agree to it."
                },
                whoIsFig: {
                    title: 'Who is Fig?',
                    content:
                        "Fig is a subsidiary of Fairstone Bank of Canada, a federally regulated Schedule I bank.\n\nWe're a small team of very real people who are trying to make the lending industry more human. To keep things lean, we skipped the brick-and-mortar location with the 9-5 hours in favour of a collaboration with Koru, a groundbreaking venture studio owned by the Ontario Teachers' Pension Plan, one of the world's largest investors.\n\nPlus, since we're backed by Fairstone Bank, we're able to take advantage of industry-leading lending expertise, all while still offering a flexible approach to financial well-being."
                }
            },
            preApproval: {
                disclaimer: {
                    title: 'Pre-qualified personal loan offer',
                    content1:
                        "A pre-qualified offer means your loan amount and interest rate are locked in. Based on the information you've provided, you're pre-qualified for up to {{loanAmount}} at a fixed interest rate of {{apr}}. Additional details will be required to finalize your approval.<br/><br/> You'll be able to choose the exact amount you want to borrow (up to the pre-qualified limit) on the next screen. As this is a loan and not a line of credit, the amount you choose will be deposited into your bank account upon completing the loan booking process."
                }
            },
            keyPointsSection: {
                title: "What's next?",
                point1: 'Just a few more steps to finalize your loan',
                point2: 'Funds deposited in as little as 1 business day',
                point3: 'Pay back anytime without prepayment penalties'
            },
            loanAmount: {
                title: 'Up to',
                description: 'Loan Amount'
            },
            apr: {
                title: 'Guaranteed at',
                description: 'Fixed APR',
                disclaimer: {
                    title: 'Guaranteed fixed APR',
                    content:
                        'Fig does not believe in misleading `bait-and-switch` offers. That means that the fixed APR will remain unchanged as you complete your application and finalize the loan. No additional hidden fees or charges.',
                    content2: 'The Annual Percentage Rate (APR) represents the total cost of borrowing over a year, expressed as a percentage.'
                }
            },
            term: {
                title: 'Up to',
                years: 'years',
                description: 'Term',
                months: 'Months'
            },
            disclaimer: {
                fullText:
                    "†You will only receive a loan offer and be approved for a loan if you meet Fig's current credit standards which include the following conditions: you do not currently have an active Fig loan and you have not been declined by Fig within the last 30 days. Any approval received is conditional to Fig's standard review which may include verification of (i) your identity, (ii) information provided as part of your application, and (iii) your ability to pay. Fig loans range from $2,000 to $35,000 with terms from 24 to 60 months. Annual Percentage Rates (APRs) range from 8.99% to 29.49%. APR is the same as interest rate. Your loan amount and APR depends on the assessment of your credit profile. Monthly payment and total cost of borrowing shown in any received offer are estimated amounts and may slightly differ from actual amounts owed. Offer excludes residents of Northwest Territories, Nunavut, and Yukon. Receive a $50 digital Walmart Gift Card for Fig personal loans between $2,000 - $10,000 and a $100 digital Walmart Gift Card for Fig personal loans between $10,001 - $35,000. Loan must be active and in good standing after 90 days (i.e., all loan payments must be successfully made for the first 90 days) in order to receive the digital gift card. After the 90th day, provided all offer conditions have been met, a digital Walmart Gift Card will be sent via email from Fig within five business days, to the email address used in the loan application. A limit of one digital Walmart gift card will be rewarded per eligible loan. Fig may, in its sole and absolute discretion, modify or suspend this gift card offer. Digital Walmart Gift Cards received in error including an error on the amount issued are subject to cancellation.",
                offerGuarantee: 'This offer is guaranteed for 15 days.'
            },
            cta: {
                buttonText: 'Get my loan',
                applyLaterText: 'Apply later'
            },
            otpSection: {
                title: 'To continue, please enter the verification code sent to your email address',
                textBelowOtpKizzo: "You'll receive emails and account updates from Fig for this loan.",
                emailAddress: '{{emailAddress}}',
                verificationCode: 'Verification Code',
                buttonText: 'Continue',
                changeEmail: 'Change',
                newEmailAddress: 'New Email Address',
                save: 'Update and resend code',
                newEmailTitle: 'Enter your new email address',
                verificationError: 'Invalid verification code. Please check your code and try again.',
                emailUpdateError: 'Failed to update your email. Please try a different email address.'
            },
            continueSection: {
                buttonText: 'Continue'
            }
        },
        embeddedOfferStep: {
            subtitle: "You're pre-qualified for a special offer!"
        },
        kizzoOfferStep: {
            title: ', you’re pre-qualified for a Kizzo loan',
            cta: {
                buttonText: 'Continue with Kizzo'
            },
            verificationCodeSection: {
                title: 'Enter the verification code sent by Fig to your email address'
            }
        },
        figtoKizzoOfferStep: {
            subtitle: 'A Kizzo loan is designed to support a wider range of credit profile but is funded and serviced by Fig.'
        },
        figTokizzoTooltip: {
            title: "You've pre-qualified for a Kizzo loan",
            intro: `Kizzo loan is a lending product provided and serviced by Fig Financial Inc. ("Fig"), designed to help more Canadians access credit. Here’s what it means for you:`,
            point1: 'Your loan is issued and serviced by Fig.',
            point2: 'All emails, statements, and correspondence will come from Fig.',
            point3: 'Loan deposits will appear in your bank account from Fig.',
            point4: 'All payments will be collected by Fig.',
            gotIt: 'Got it'
        },
        kizzoToKizzoOfferStep: {
            subtitle: 'You’re pre-qualified for a Kizzo loan, issued and serviced by Fig.'
        },
        kizzoToKizzoTooltip: {
            title: 'About Fig',
            intro: `Fig Financial Inc. ("Fig") is the lender and loan servicer for your loan offer. Here’s what that means for you:`,
            point1: 'Your loan is issued and serviced by Fig.',
            point2: 'All emails, statements, and correspondence will come from Fig.',
            point3: 'Loan deposits will appear in your bank account from Fig.',
            point4: 'All payments will be collected by Fig.',
            gotIt: 'Got it'
        },
        kizzotoFigOfferStep: {
            title: 'Congratulations, ',
            subtitle: `You're pre-qualified for a Fig loan at a lower rate.`,
            cta: {
                buttonText: 'Continue with Fig'
            }
        },
        kizzotoFigTooltip: {
            title: "You've pre-qualified for a Fig loan",
            intro: `Great news - your credit profile pre-qualifies you for a loan directly from Fig Financial Inc. ("Fig"). Here’s what it means for you:`,
            point1: 'Based on your profile, you qualify for a lower-rate loan from Fig.',
            point2: 'Your loan will be issued and serviced by Fig.',
            point3: 'All emails, statements, and correspondence will come from Fig.',
            point4: 'Loan deposits will appear in your bank account from Fig.',
            point5: 'All payments will be collected by Fig.',
            gotIt: 'Got it'
        },
        declinedStep: {
            generic: {
                title: "Sorry, we aren't able to offer you a loan right now. Rest assured, your credit score was not affected.",
                subtitle:
                    'To learn more about why you may not have been approved, you can visit our help centre. For any other questions and concerns, please reach out to us via <0>Fig live chat</0> to the bottom right of this page or email <1>Fig support</1>.',
                buttonText: 'Visit help centre'
            },
            region: {
                title: "Sorry, we aren't able to offer you a loan right now.",
                subtitle: 'Fig currently does not operate in Northwest Territories, Yukon and Nunavut. We apologize for the inconvenience.',
                buttonText: 'Go to homepage'
            },
            existingBorrower: {
                title: "You've already got a loan with us!",
                subtitle:
                    'Visit your Fig account for details of your loan. Got questions? Visit our help centre to get the answers you need. For other concerns please reach out to us via Fig live chat to the bottom right of this page or email Fig support.',
                buttonText: 'Log in to my Fig Account',
                secondaryButtonText: 'Visit help centre'
            },
            existingBorrowerRenewalEligible: {
                title: "You've already got a loan with us!",
                subtitle:
                    'Visit your Fig account for details of your loan. Got questions? Visit our help centre to get the answers you need. For other concerns please reach out to us via Fig live chat to the bottom right of this page or email Fig support.',
                buttonText: 'Log in to my Fig Account',
                secondaryButtonText: 'Request loan amount increase'
            },
            mismatch: {
                title: "Sorry, we weren't able to confirm your identity based on the information provided.",
                subtitle:
                    'Please verify your details and try again. For any other questions and concerns, please reach out to us via Fig live chat to the bottom right of this page or email Fig support.',
                buttonText: 'Try again'
            },
            tuNoHit: {
                title: 'Looks like we need a little more information. Can you provide your Social Insurance Number?',
                subtitle:
                    "Your name and address alone weren't enough for us to confirm that we had the right person. This can happen if you've recently moved or changed your name. To continue, we'll need your social insurance number.",
                inputLabel: 'Social Insurance Number (optional)',
                buttonText: 'Get my offer'
            }
        }
    }
}
